import { defineMessages } from "react-intl";

export const messages = defineMessages({
  btnSave: {
    id: "tagUpdateModal.btnSave",
    defaultMessage: "Save",
  },
  btnReturn: {
    id: "tagUpdateModal.btnReturn",
    defaultMessage: "Return back",
  },
  btnClearAll: {
    id: "tagUpdateModal.btnClearAll",
    defaultMessage: "Delete all",
  },
  selectPlaceholder: {
    id: "tagUpdateModal.selectPlaceholder",
    defaultMessage: "Select tags...",
  },
});
